import { useSyncExternalStore } from "react";

export type EchoSelection = {
  echoId: string;
  sceneId: string | number | null;
  index: number;
  seconds: number | null;
};
type Binding = {
  selection: EchoSelection;
  seek: (seconds: number) => void;
  pause?: () => void;
};
let binding: Binding | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());
const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

/** Presentation state only. Server authorization never trusts this selection. */
export function bindEchoPlayer(
  selection: EchoSelection,
  seek: (seconds: number) => void,
  pause?: () => void,
) {
  const own = { selection, seek, pause };
  binding = own;
  notify();
  return () => {
    if (binding === own) {
      binding = null;
      notify();
    }
  };
}
export function useEchoSelection(echoId: string) {
  return useSyncExternalStore(
    subscribe,
    () => (binding?.selection.echoId === echoId ? binding.selection : null),
    () => null,
  );
}
export function seekEcho(echoId: string, seconds: number) {
  if (
    binding?.selection.echoId === echoId &&
    Number.isFinite(seconds) &&
    seconds >= 0
  )
    binding.seek(seconds);
}

export function pauseEcho(echoId: string) {
  if (binding?.selection.echoId === echoId) binding.pause?.();
}
